// Minimal Vuetify configuration - only essential components
import { createVuetify } from 'vuetify'

// Unfortunately, we need to import Vuetify styles for components to work
// We'll override the font inheritance in our SCSS
import 'vuetify/styles'

// Icons
import '@mdi/font/css/materialdesignicons.css'

// Import ONLY essential components
import {
  // Layout
  VApp,
  VMain,
  VContainer,
  VRow,
  VCol,
  VSpacer,
  
  // Basic Components
  VBtn,
  VIcon,
  VDivider,
  
  // Cards
  VCard,
  VCardText,
  VCardTitle,
  VCardActions,
  
  // Form Inputs
  VTextField,
  VForm,

  // Feedback
  VSnackbar,
} from 'vuetify/components'

// DO NOT import individual component CSS files - they don't exist in Vuetify 3
// Instead, we'll create our own minimal styles for these components

export default createVuetify({
  components: {
    VApp,
    VMain,
    VContainer,
    VRow,
    VCol,
    VSpacer,
    VBtn,
    VIcon,
    VDivider,
    VCard,
    VCardText,
    VCardTitle,
    VCardActions,
    VTextField,
    VForm,
    VSnackbar,
  },
  directives: {
    // No directives needed for basic functionality
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#EB661F',      // Banjino orange
          secondary: '#285338',    // Dark green
          accent: '#F3D69C',       // Desert tan
          error: '#D32F2F',
          info: '#767934',
          success: '#285338',
          warning: '#D35616',
          background: '#FFF5E6',
        },
      },
    },
  },
  defaults: {
    global: {
      ripple: false // Disable ripple to avoid extra JS
    },
    VBtn: {
      variant: 'flat',
      rounded: 'pill',
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
    }
  }
})